module.exports = __webpack_public_path__ + "static/media/bombbanner_sm3.08f8a7a4.png";